import { createAction, props } from '@ngrx/store';

export const cambiarPago = createAction('[Fprs] Cambiar Pago', props<{ fpr: object }>());

export type accionesValidas = typeof cambiarPago;
